export default "__VITE_ASSET__gFO6Euru__"